const showAll = (btnSelect, containerShowSelect, tagsBlock = false) => {

	let btnSelectShow = document.querySelector(btnSelect);
	let showBlock; let firstHeight; let firstTitle;

	// работаем с кнопкой
	if(btnSelectShow) {
		firstTitle = btnSelectShow.textContent; //исходный заголовок кнопки

		showBlock = btnSelectShow.parentNode.querySelector(containerShowSelect); //блок который нужно открыть
		firstHeight = showBlock.clientHeight;

		// скрываем кнопку для облака тегов
		if(tagsBlock && showBlock.scrollHeight <= 57) {
			btnSelectShow.style.display = 'none';
		}

		// скрываем кнопку, если контента меньше, чем высота контейнера
		if(!tagsBlock && (showBlock.clientHeight <= showBlock.scrollHeight)){
			btnSelectShow.style.visibility = 'hidden';
			showBlock.style.height = 'auto';
		}
	}
	
	
	// открыть/закрыть контент
	try {
		btnSelectShow.addEventListener('click', ()=>{
			if(btnSelectShow.classList.contains('active')) {
				showBlock.style.height = firstHeight + 'px';
				btnSelectShow.classList.remove('active');
				// btnSelectShow.textContent = btntextContent;
				btnSelectShow.textContent = firstTitle;
				
			} else {
				if(tagsBlock) {
					if(showBlock.scrollHeight > 57) {
						showBlock.style.height = showBlock.scrollHeight + 'px';
						btnSelectShow.classList.add('active');
						btnSelectShow.textContent = "Скрыть";
					}
				} else {
					showBlock.style.height = showBlock.scrollHeight + 'px';
					btnSelectShow.classList.add('active');
					btnSelectShow.textContent = "Скрыть";
				}
				
			}
		});
	} catch(e){}
}

export default showAll;
